import { render, staticRenderFns } from "./UpdateSnowflakeCredentialsDialog.vue?vue&type=template&id=5a9dcc5b&"
import script from "./UpdateSnowflakeCredentialsDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateSnowflakeCredentialsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports